module.exports = __webpack_public_path__ + "static/img/pj-sbg.da784ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/pj-sbg.png
// module id = w4no
// module chunks = 1